import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Table, Button, Col, Modal, Row, Container, Dropdown, Alert, Form } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LoginManager } from '../../core/login-manager';
import { LanguageProvider } from '../../core/language-provider';
import ModalList from '../../components/Modals/ModalList';
import ModalEntityViewer from '../../components/Modals/ModalEntityViewer';
import ModalListPicker from '../../components/Modals/ModalListPicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import moment from 'moment';
import { WriteXml } from 'fattura-elettronica';
import { settings } from '../settings';
import { Editor } from '@tinymce/tinymce-react';



export default function DataGridLastTdHook({ item, props, entity = null, refreshData }) {

    const navigate = useNavigate()


    //customer
    const [customerHistoryEntity, setCustomerHistoryEntity] = useState(null)
    const [customerHistorySearchObj, setCustomerHistorySearchObj] = useState(null)
    const [statusCustomerModal, setStatusCustomerModal] = useState(false)
    const [statusPaymentModal, setStatusPaymentModal] = useState(false)
    const [paymentEntity, setPaymentyEntity] = useState(null)
    const [paymentSearchObj, setPaymentSearchObj] = useState(null)
    const [statusPaymentOrderModal, setStatusPaymentOrderModal] = useState(false)
    const userInfo = LoginManager.getUserInfo();
    function showCustomerOffer(item) {
        let query = ''
        let fields = []
        let constraints = [{ "fieldName": "idCustomer", type: "value", value: item.id }]

        setCustomerHistorySearchObj({
            query: query,
            fields: fields,
            constraints: constraints
        })

        setCustomerHistoryEntity('customer_offer')
        setStatusCustomerModal(true)
    }
    function showCustomerOrder(item) {
        let query = ''
        let fields = []
        let constraints = [{ "fieldName": "idCustomer", type: "value", value: item.id }]

        setCustomerHistorySearchObj({
            query: query,
            fields: fields,
            constraints: constraints
        })

        setCustomerHistoryEntity('customer_order')
        setStatusCustomerModal(true)
    }
    function closeCustomerModal() {
        setCustomerHistoryEntity(null)
        setStatusCustomerModal(false)
    }



    function showModalPayment(item) {
        let query = ''
        let fields = []
        let constraints = [{ "fieldName": "idCustomer", type: "value", value: item.id }]

        setPaymentSearchObj({
            query: query,
            fields: fields,
            constraints: constraints
        })

        setPaymentyEntity('customer_order_payment')
        setStatusPaymentModal(true)
    }
    function closeModalPayment() {
        setPaymentyEntity(null)
        setStatusPaymentModal(false)
    }

    function newCustomerOffer(item) {
        navigate('/entity/customer_offer/add', {
            state: {
                body: {
                    idCustomer: item
                }
            }
        })
    }
    function newCustomerOrder(item) {
        navigate('/entity/customer_order/add', {
            state: {
                body: {
                    idCustomer: item
                }
            }
        })
    }




    //customer offer
    function previewCustomerOffer(item) {
        navigate('/page/CustomerOfferPreview?id=' + item.id)
    }
    const [statusModalEntityViewerCustomerOffer, setStatusModalEntityViewerCustomerOffer] = useState(false)
    function closeModalEntityViewerCustomerOffer() {
        setStatusModalEntityViewerCustomerOffer(false)
    }
    function openModalEntityViewerCustomerOffer() {
        setStatusModalEntityViewerCustomerOffer(true)
    }

    const [statusModalEntityViewerCustomerOrder, setStatusModalEntityViewerCustomerOrder] = useState(false)
    function closeModalEntityViewerCustomerOrder() {
        setStatusModalEntityViewerCustomerOrder(false)
    }
    function openModalEntityViewerCustomerOrder() {
        setStatusModalEntityViewerCustomerOrder(true)
    }

    const [statusModalEntityViewerSupplierOrder, setStatusModalEntityViewerSupplierOrder] = useState(false)
    function closeModalEntityViewerSupplierOrder() {
        setStatusModalEntityViewerSupplierOrder(false)
    }
    function openModalEntityViewerSupplierOrder() {
        setStatusModalEntityViewerSupplierOrder(true)
    }



    //customer order
    function previewCustomerOrder(item) {
        navigate('/page/CustomerOrderPreview?id=' + item.id)
    }
    function ddtCustomerOrder(item) {
        navigate('/page/CustomerDdtPreview?id=' + item.id)
    }

    function newCustomerOrderPayment(item) {
        navigate('/entity/customer_order_payment/add', {
            state: {
                body: {
                    idCustomerOrder: item
                }
            }
        })
    }



    const [dataPaymentOrderModal, setDataPaymentOrderModal] = useState(false)
    async function showModalPaymentOrder(item) {
        setStatusPaymentOrderModal(true)

        let constraints = [{ "fieldName": "idCustomerOrder", type: "value", value: item.id }]
        var response = await DataManager.searchItems('customer_order_payment', 1, 100, { 'field': 'id', 'order': 'desc' }, '', [], constraints)
        if (response.success === 1) {
            setDataPaymentOrderModal(response.body)
            console.warn(response.body)
        }
    }
    function closeModalPaymentOrder() {
        setStatusPaymentOrderModal(false)
        setDataPaymentOrderModal(null)
    }



    //supplier order
    function previewSupplierOrder(item) {
        navigate('/page/SupplierOrderPreview?id=' + item.id)
    }


    async function customerOfferConvertInOrder() {
        var userInfo = LoginManager.getUserInfo();
        console.warn('item', item)
        const id = toast.loading("Conversione preventivo...")

        if (item.status && item.status.value === "10_CONFIRMED") {
            toast.update(id, { render: "Questo preventivo è già stato convertito in ordine.", type: "error", isLoading: false, autoClose: 3000, closeOnClick: true, theme: "colored" });
        }
        else {
            var body = {
                status: { value: '10_CONFIRMED' }
            }
            var response = await DataManager.updateItem('customer_offer', body, item.id)
            console.warn(response)
            if (response.success === 1) {
                var sorting = {
                    'field': 'id',
                    'order': 'desc'
                }
                var constraints = [{ "fieldName": "levelUser", type: "value", value: 1 }]
                var resNotifiche = await DataManager.searchItems('gyv_notification', 1, 50, sorting, '', [], constraints);
                console.log(resNotifiche);
                if (resNotifiche.success === 1 && resNotifiche.body.length > 0) {
                    for (let i = 0; i < resNotifiche.body.length; i++) {
                        if (resNotifiche.body[i].notificationAll === 1 && resNotifiche.body[i].notificationOffer === 1) {
                            var bodyEmail = {
                                emailTo: resNotifiche.body[i].emailUser,
                                riferimento: item.internalCode,
                                idOrder: item.id,
                                entity: 'offer',
                                stato: 'CONVERTITO IN ORDINE'
                            }
                            var responseEmail = await ApiManager.sendAuthenticatedRequest('/custom/send_mail_change_status', bodyEmail);
                            console.warn(responseEmail);
                        }
                    }
                }

                var sortingOffer = {
                    'field': 'id',
                    'order': 'desc'
                }
                var constraintsOffer = [{ "fieldName": "id", type: "value", value: item.id }]
                var resultOffer = await DataManager.searchItems('customer_offer', 1, 50, sortingOffer, '', [], constraintsOffer);
                if (resultOffer.success === 1) {

                    console.log(resultOffer);
                    toast.update(id, { render: "Preventivo confermato. Compila l'ordine con i campi mancanti. RICORDATI DI SALVARE L'ORDINE.", type: "success", isLoading: false, autoClose: 3000, closeOnClick: true, theme: "colored" });
                    navigate('/entity/customer_order/add', {
                        state: {
                            body: {
                                idCustomerOffer: { id: item.id },
                                idCustomer: { id: resultOffer.body[0].idCustomer.id, name: resultOffer.body[0].idCustomer.name },
                                idSalesAgent: resultOffer.body[0].idSalesAgent,
                                discount: resultOffer.body[0].discount,
                                notes: resultOffer.body[0].notes,
                                rows: resultOffer.body[0].rows,
                                files: resultOffer.body[0].files,
                                riferimento: resultOffer.body[0].riferimento,
                                status: { value: '0_PENDING' },
                                vat: resultOffer.body[0].vat,
                                idPaymentCondition: resultOffer.body[0].idPaymentCondition ? { id: resultOffer.body[0].idPaymentCondition.id, name: resultOffer.body[0].idPaymentCondition.name } : null,
                                parking: resultOffer.body[0].parking,
                                parquet: resultOffer.body[0].parquet,
                                pedestrian_zone: resultOffer.body[0].pedestrian_zone,
                                hoist_elevator: resultOffer.body[0].hoist_elevator,
                                floor: resultOffer.body[0].floor,
                                no_traffic_zone: resultOffer.body[0].no_traffic_zone,
                                building: resultOffer.body[0].building,
                                zone: resultOffer.body[0].zone,
                                ladder_truck: resultOffer.body[0].ladder_truck,
                                elevator: resultOffer.body[0].elevator,
                                increase: resultOffer.body[0].increase,
                                discount: resultOffer.body[0].discount,
                                transportCost: resultOffer.body[0].transportCost,
                                deliveryDate: resultOffer.body[0].deliveryDate,
                                deliveryAddress: resultOffer.body[0].deliveryAddress,
                                locality: resultOffer.body[0].locality,
                            }
                        }
                    })

                }


                console.log(body);
            }
            else {
                if (response.message && response.message != '') {
                    toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000, closeOnClick: true, theme: "colored" });
                }
                else {
                    toast.update(id, { render: "Non è stato possibile convertire questo preventivo.", type: "error", isLoading: false, autoClose: 3000, closeOnClick: true, theme: "colored" });
                }
            }
        }
    }


    async function revert() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [{ "fieldName": "idCustomerOffer", type: "value", value: item.id }]
        var result = await DataManager.searchItems('customer_order', 1, 50, sorting, '', [], constraints);
        if (result.success === 1) {
            if (result.body.length > 0) {
                toast.error('Impossibile fare il revert in quanto è già presente un ordine creato da questo preventivo', { theme: 'colored' })
            } else {
                var data = {
                    status: { value: '0_PENDING' }
                }
                var update = await DataManager.updateItem('customer_offer', data, item.id);
                if (update.success === 1) {
                    toast.success('Revert eseguito con successo!', { theme: 'colored' })
                    refreshData()
                }
            }
        }

    }

    const [statusModalCheck, setStatusModalCheck] = useState(false)
    function closeModalCheck() {
        setStatusModalCheck(false)
    }
    function openModalCheck() {
        setStatusModalCheck(true)
    }

    const [totConfirm, setTotConfirm] = useState(null)
    const [totRows, setTotRows] = useState(null)
    async function checkPrice() {
        var res = await DataManager.getItem('supplier_order', item.id);
        console.log(res)
        if (res.success === 1) {
            var so = res.body[0]
            var a = so.rows.reduce((a, c) => a + parseFloat(c.listPriceOrder), 0);
            if (so.idSupplier.cash_flow_discount !== "0") {
                console.log(a, so.idSupplier.cash_flow_discount)
                a = parseFloat(a) - (parseFloat(a) * parseInt(so.idSupplier.cash_flow_discount) / 100)
                console.log(a)
            }
            if (so.idSupplier.commercial_discount !== "0") {
                console.log(a, so.idSupplier.commercial_discount)
                a = parseFloat(a) - (parseFloat(a) * parseInt(so.idSupplier.commercial_discount) / 100)
            }


            if (so.files !== null) {
                var b = so.files.reduce((acc, cur) => acc + parseFloat(cur.cost), 0);
            } else {
                var b = parseFloat("0,00")
            }
            setTotConfirm(b)
            setTotRows(a)
            openModalCheck()
        }
    }

    function goToPreview() {
        navigate('/page/PaymentsPreview?id=' + item.id)
    }

    async function declined(){
        var update = await DataManager.updateItem('customer_offer', {status: {value: "20_DECLINED"}}, item.id)
        if(update.success === 1){
            toast.success("Preventivo rifiutato con successo!", {theme: 'colored'})
            refreshData()
        }else {
            toast.error(update.message, {theme: 'colored'});
        }
    }



    function downloadXml() {
        const xmlString = item.xml;

        const blob = new Blob([xmlString], { type: 'application/xml' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'file.xml';

        document.body.appendChild(a);
        a.click();

        a.remove();
    }

    async function generateXml(item) {
        console.log(item)
        if (item.progressivo !== null) {
            var res = await DataManager.getItem('customer_order', item.idCustomerOrder.id);
            if (res.success === 1) {
                var r = res.body[0];
                var temp = [];
                for (let i = 0; i < r.rows.length; i++) {
                    temp.push({
                        NumeroLinea: i + 1,
                        Descrizione: r.rows[i].description,
                        Quantita: r.rows[i].quantity + '.0000',
                        UnitaMisura: 'PZ',
                        PrezzoUnitario: parseFloat(r.rows[i].listPrice).toFixed(2),
                        PrezzoTotale: parseFloat(r.rows[i].price).toFixed(2),
                        AliquotaIVA: r.vat + '.00'
                    })
                }

                console.log(res)


                var dateNow = moment().format('YYYY-MM-DD');

                const fattura = {
                    FatturaElettronicaHeader: {
                        DatiTrasmissione: {
                            IdTrasmittente: {
                                IdPaese: settings.dati_fattura.statoPIVA,
                                IdCodice: settings.dati_fattura.PIVA,
                            },
                            ProgressivoInvio: item.progressivo,
                            FormatoTrasmissione: settings.dati_fattura.formatoTrasmissione,
                            CodiceDestinatario: settings.dati_fattura.codiceDestinatario,
                        },
                        CedentePrestatore: {
                            DatiAnagrafici: {
                                IdFiscaleIVA: {
                                    IdPaese: settings.dati_fattura.statoPIVA,
                                    IdCodice: settings.dati_fattura.PIVA,
                                },
                                CodiceFiscale: settings.dati_fattura.PIVAcompleta,
                                Anagrafica: {
                                    Denominazione: settings.dati_fattura.denominazione,
                                },
                                RegimeFiscale: settings.dati_fattura.regimeFiscale,
                            },
                            Sede: {
                                Indirizzo: settings.dati_fattura.indirizzo,
                                CAP: settings.dati_fattura.cap,
                                Comune: settings.dati_fattura.comune,
                                Provincia: settings.dati_fattura.provincia,
                                Nazione: settings.dati_fattura.nazione
                            },
                            IscrizioneREA: {
                                Ufficio: settings.dati_fattura.ufficio,
                                NumeroREA: settings.dati_fattura.numeroREA,
                                SocioUnico: settings.dati_fattura.socioUnico,
                                StatoLiquidazione: settings.dati_fattura.statoLiquidazione
                            },
                        },
                        CessionarioCommittente: {
                            DatiAnagrafici: {
                                IdFiscaleIVA: {
                                    IdPaese: 'IT',
                                    IdCodice: r.idCustomer.vatNumber
                                },
                                CodiceFiscale: r.idCustomer.vatNumber,
                                Anagrafica: {
                                    Denominazione: r.idCustomer.name,
                                },
                            },
                            Sede: {
                                Indirizzo: r.idCustomer.route + ', ' + r.idCustomer.streetNumber,
                                CAP: r.idCustomer.postalCode,
                                Comune: r.idCustomer.locality,
                                Provincia: r.idCustomer.province,
                                Nazione: r.idCustomer.country
                            },
                        },
                    },
                    FatturaElettronicaBody: [
                        {
                            DatiGenerali: {
                                DatiGeneraliDocumento: {
                                    TipoDocumento: 'TD01',
                                    Divisa: 'EUR',
                                    Data: dateNow,
                                    Numero: r.internalCode,
                                    ImportoTotaleDocumento: parseFloat(r.totalPrice).toFixed(2),
                                    /* Arrotondamento: '', */
                                    Causale: ''
                                },
                            },
                            DatiBeniServizi: {
                                DettaglioLinee: temp,
                                DatiRiepilogo: [
                                    {
                                        AliquotaIVA: r.vat + '.00',
                                        Arrotondamento: '',
                                        ImponibileImporto: r.totalPrice,
                                        /* Imposta: '00.00',
                                        EsigibilitaIVA: '' */
                                    },

                                ],
                            }
                        },
                    ],
                };

                console.warn(fattura)


                const xmlString = WriteXml(fattura);

                const blob = new Blob([xmlString], { type: 'application/xml' });
                const url = URL.createObjectURL(blob);

                var data = {
                    xml: xmlString,
                }
                console.log(data)
                var resUpdate = await DataManager.updateItem('invoice', data, item.id);
                console.log(resUpdate)
                if (resUpdate.success === 1) {
                    toast.success("XML rigenerato con successo.", { theme: 'colored' })
                    refreshData()
                } else {
                    toast.error("Errore nel generare il file XML", { theme: 'colored' })
                }
            } else {
                toast.warning("Inserire un progressivo per poter procedere.", { theme: 'colored' })
            }


        }
    }





    const [showModal, setShowModal] = useState(null);
    const [progressivo, setProgressivo] = useState(null);
    const [descrizione, setDescrizione] = useState(null);
    const [aliquota, setAliquota] = useState(null);
    const [causale, setCausale] = useState(null);
    function closeModal() {
        setShowModal(false)
    }
    function openModal() {
        setShowModal(true)
    }

    async function generateXMLV2() {
        closeModal()
        console.log(item)
        var dateNow = moment().format('YYYY-MM-DD');


        const fattura = {
            FatturaElettronicaHeader: {
                DatiTrasmissione: {
                    IdTrasmittente: {
                        IdPaese: settings.dati_fattura.statoPIVA,
                        IdCodice: settings.dati_fattura.PIVA,
                    },
                    ProgressivoInvio: progressivo,
                    FormatoTrasmissione: settings.dati_fattura.formatoTrasmissione,
                    CodiceDestinatario: item.idCustomer.sdi,
                    PECDestinatario: item.idCustomer.pec
                },
                CedentePrestatore: {
                    DatiAnagrafici: {
                        IdFiscaleIVA: {
                            IdPaese: settings.dati_fattura.statoPIVA,
                            IdCodice: settings.dati_fattura.PIVA,
                        },
                        CodiceFiscale: settings.dati_fattura.PIVAcompleta,
                        Anagrafica: {
                            Denominazione: settings.dati_fattura.denominazione,
                        },
                        RegimeFiscale: settings.dati_fattura.regimeFiscale,
                    },
                    Sede: {
                        Indirizzo: settings.dati_fattura.indirizzo,
                        CAP: settings.dati_fattura.cap,
                        Comune: settings.dati_fattura.comune,
                        Provincia: settings.dati_fattura.provincia,
                        Nazione: 'IT'
                    },
                    IscrizioneREA: {
                        Ufficio: settings.dati_fattura.ufficio,
                        NumeroREA: settings.dati_fattura.numeroREA,
                        SocioUnico: settings.dati_fattura.socioUnico,
                        StatoLiquidazione: settings.dati_fattura.statoLiquidazione
                    },
                },
                CessionarioCommittente: {
                    DatiAnagrafici: {
                        IdFiscaleIVA: {
                            IdPaese: 'IT',
                            IdCodice: item.idCustomer.vatNumber
                        },
                        CodiceFiscale: item.idCustomer.vatNumber,
                        Anagrafica: {
                            Denominazione: item.idCustomer.name,
                        },
                    },
                    Sede: {
                        Indirizzo: item.idCustomer.route + ', ' + item.idCustomer.streetNumber,
                        CAP: item.idCustomer.postalCode,
                        Comune: item.idCustomer.locality,
                        Provincia: item.idCustomer.province,
                        Nazione: 'IT'
                    },
                },
            },
            FatturaElettronicaBody: [
                {
                    DatiGenerali: {
                        DatiGeneraliDocumento: {
                            TipoDocumento: 'TD01',
                            Divisa: 'EUR',
                            Data: dateNow,
                            Numero: progressivo,
                            ImportoTotaleDocumento: parseFloat(item.totalPayment).toFixed(2),
                            Causale: causale
                        },
                    },
                    DatiBeniServizi: {
                        DettaglioLinee: [{
                            NumeroLinea: 1,
                            Descrizione: descrizione,
                            Quantita: '1.0000',
                            PrezzoUnitario: parseFloat(item.totalPayment).toFixed(2),
                            PrezzoTotale: parseFloat(item.totalPayment).toFixed(2),
                            AliquotaIVA: aliquota + '.00',
                        }],
                        DatiRiepilogo: [
                            {
                                AliquotaIVA: aliquota + '.00',
                                ImponibileImporto: parseFloat(item.totalPayment).toFixed(2),
                                Imposta: parseFloat(parseFloat(item.totalPayment) * (aliquota / 100)).toFixed(2)
                            },

                        ],
                    }
                },
            ],
        };

        console.warn(fattura)

        const xmlString = WriteXml(fattura);

        const blob = new Blob([xmlString], { type: 'application/xml' });
        const url = URL.createObjectURL(blob);


        const a = document.createElement('a');
        a.href = url;
        a.download = 'file.xml';

        document.body.appendChild(a);
        a.click();

        a.remove();

        var updateBody = {
            progressivo: progressivo,
            vat: aliquota,
            description: descrizione,
            status: { value: '5_GENERATE' }
        }
        var res = await DataManager.updateItem('customer_order_payment', updateBody, item.id)
        if (res.success === 1) {
            toast.success("XML generato con successo!", { theme: 'colored' })
            refreshData()
        } else {
            toast.error("Errore.", { theme: 'colored' })
        }

    }

    async function paidInvoice() {
        var updateBody = {
            status: { value: '5_GENERATE' }
        }
        var res = await DataManager.updateItem('customer_order_payment', updateBody, item.id)
        if (res.success === 1) {
            toast.success("Fattura pagata con successo!", { theme: 'colored' })
            refreshData()
        } else {
            toast.error("Errore.", { theme: 'colored' })
        }
    }






    const [statusModalLocation, setStatusModalLocation] = useState(false)
    const [statusModalRows, setStatusModalRows] = useState(false)
    const [dataRows, setDataRows] = useState(false)


    function closeModalLocation() {
        setStatusModalLocation(false)
    }
    async function openModalLocation() {
        setStatusModalLocation(true)
    }




    function closeModalRows() {
        setStatusModalRows(false)
    }
    async function openModalRows() {
        let constraints = [{ "fieldName": "internalCode", type: "value", value: item.idCustomerOrder }]
        var response = await DataManager.searchItems('customer_order', 1, 100, { 'field': 'id', 'order': 'desc' }, '', [], constraints)
        if (response.success === 1) {
            setDataRows(response.body[0])
            setStatusModalRows(true)
        }

    }

    const [idArray, setIdArray] = useState([]);
    function toggleId(id) {
        setIdArray(prev =>
            prev.includes(id)
                ? prev.filter(x => x !== id)     // se già dentro, lo rimuovo
                : [...prev, id]                  // altrimenti lo aggiungo
        )
    }

    async function selectRow(e) {
        console.log(e)
        closeModalLocation();
        closeModalRows()
        var body = {
            idLocation: { id: e.id }
        }
        var count = 0;
        for (let i = 0; i < idArray.length; i++) {
            var res = await DataManager.updateItem('customer_order_row', body, idArray[i])
            if (res.success === 1) {
                toast.success("Locazione inserita con successo.", { theme: 'colored' })
                count++;
            } else {
                toast.error("Errore.", { theme: 'colored' })
            }
        }
        if (count === idArray.length) {
            closeModalLocation();
            setIdArray([])
        } else {
            setIdArray([])
        }

    }








    const [statusModalCheckOffer, setStatusModalCheckOffer] = useState(false)
    function closeModalCheckOffer() {
        setStatusModalCheckOffer(false)
    }
    function openModalCheckOffer(id) {
        setStatusModalCheckOffer(true)
    }

    const [totConfirmOffer, setTotConfirmOffer] = useState(null)
    const [totRowsOffer, setTotRowsOffer] = useState(null)
    const [aboluteMargin, setAbsoluteMargin] = useState(null)
    const [margin, setMargin] = useState(null)
    async function checkPriceOffer() {
        openModalCheckOffer()
        var res = await DataManager.getItem('customer_offer', item.id);
        console.log(res)
        if (res.success === 1) {
            var co = res.body[0]
            var a = co.rows.reduce((a, c) => a + (parseFloat(c.listPrice) * parseFloat(c.quantity)), 0);
            const b = co.rows.reduce((sum, c) => {
                const price = parseFloat(c.listPrice) || 0;
                const qty = parseFloat(c.quantity) || 0;

                // Costruiamo il moltiplicatore partendo da 1
                let multiplier = 1;

                // Se commercial è diverso da "0" e non è vuoto, lo applichiamo
                if (
                    c.idSupplier.commercial_discount !== "0" &&
                    c.idSupplier.commercial_discount !== ""
                ) {
                    multiplier *= (parseFloat(c.idSupplier.commercial_discount) || 0) / 100;
                }

                console.log(multiplier)
                // Se cash_flow_discount è diverso da "0" e non è vuoto, lo applichiamo
                if (
                    c.idSupplier.cash_flow_discount !== "0" &&
                    c.idSupplier.cash_flow_discount !== ""
                ) {
                    multiplier *= (1 - (parseFloat(c.idSupplier.cash_flow_discount) || 0) / 100);
                }
                console.log(multiplier)

                console.log(sum, price, qty, multiplier)
                // Sommiamo il contributo di questa riga
                return sum + price * qty * multiplier;
            }, 0);

            const absoluteMargin = a - b;
            const markupPercentage = ((a - b) / a) * 100;

            console.log(b)
            setTotConfirmOffer(b)
            setTotRowsOffer(a)
            setAbsoluteMargin(absoluteMargin)
            setMargin(markupPercentage)

        }
        openModalCheckOffer()
    }






    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample':
                            return (
                                <span>Test</span>
                            );
                        case 'customer':
                            return (
                                <>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="outline-secondary" size='sm'>
                                            Azioni
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => showCustomerOffer(item)} className='py-0'>Preventivi</Dropdown.Item>
                                            <Dropdown.Item onClick={() => newCustomerOffer(item)} className='py-0'>Crea preventivo</Dropdown.Item>
                                            <hr className='my-2' />
                                            <Dropdown.Item onClick={() => showCustomerOrder(item)} className='py-0'>Ordini</Dropdown.Item>
                                            <Dropdown.Item onClick={() => newCustomerOrder(item)} className='py-0'>Crea ordine</Dropdown.Item>
                                            <hr className='my-2' />
                                            <Dropdown.Item onClick={() => showModalPayment(item)} className='py-0'>Storico pagamenti</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>


                                    {statusCustomerModal && customerHistoryEntity ? <ModalList entity={customerHistoryEntity} searchObj={customerHistorySearchObj} status={statusCustomerModal} closeModal={closeCustomerModal} /> : <></>}
                                    {statusPaymentModal && paymentEntity ? <ModalList entity={paymentEntity} searchObj={paymentSearchObj} status={statusPaymentModal} closeModal={closeModalPayment} /> : <></>}

                                </>
                            );
                        case 'gyv_customer_offer':
                            return (
                                <>
                                    {(parseInt(userInfo.level) === 0 || parseInt(userInfo.level) === 1) ? <>
                                        <Button className='m-1' variant='outline-secondary' size='sm' onClick={() => checkPriceOffer()}>Calcolo margine</Button>
                                    </> : null}

                                    {item.status.value === '0_PENDING' || item.status.value === '5_PRESALE' ?
                                        <Button className='m-1' variant='outline-success' size='sm' onClick={() => customerOfferConvertInOrder()}>Converti</Button>
                                        : <></>}

                                    {item.status.value === '0_PENDING' ? <>
                                        <Button className='m-1' variant='danger' size='sm' onClick={() => declined()}>Rifiutato</Button>
                                    </> : null}
                                    {item.status.value === '10_CONFIRMED' ? <>
                                        <Button className='m-1' variant='outline-danger' size='sm' onClick={() => revert()}>Annulla</Button>
                                    </> : null}
                                    <Button className='m-1' variant='outline-primary' size='sm' onClick={() => openModalEntityViewerCustomerOffer()}>Dettagli</Button>
                                    <Button onClick={() => previewCustomerOffer(item)} size="sm" variant="outline-secondary" className='m-1'><FontAwesomeIcon className='ms-1 me-1' icon='print'></FontAwesomeIcon></Button>

                                    {statusModalEntityViewerCustomerOffer !== false && (
                                        <ModalEntityViewer entity={'customer_offer'} item={item} status={statusModalEntityViewerCustomerOffer} closeModal={closeModalEntityViewerCustomerOffer} />
                                    )}



                                    <Modal show={statusModalCheckOffer} onHide={closeModalCheckOffer} size='lg'>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Margine</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Prezzo di listino articoli</p>
                                                    <h3>{parseFloat(totRowsOffer).toLocaleString('it-IT', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })} €</h3>
                                                </Col>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Costo stimato articoli</p>
                                                    <h3>{parseFloat(totConfirmOffer).toLocaleString('it-IT', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })} €</h3>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Margine assoluto</p>
                                                    <h3>{parseFloat(aboluteMargin).toLocaleString('it-IT', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })} €</h3>
                                                </Col>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Margine percentuale</p>
                                                    <h3>{parseInt(margin)} %</h3>
                                                </Col>
                                            </Row>
                                        </Modal.Body>
                                    </Modal>




                                </>
                            );
                        case 'gyv_customer_order':
                            return (
                                <>
                                    <div className='d-flex'>


                                        {/* <Button className='me-1' variant='outline-primary' size='sm' onClick={() => createInvoice(item)}>Crea fattura</Button> */}

                                        <Dropdown>
                                            <Dropdown.Toggle variant="outline-secondary" size='sm'>
                                                Azioni
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => ddtCustomerOrder(item)} className='py-0'>Scheda di consegna</Dropdown.Item>
                                                <Dropdown.Item onClick={() => openModalEntityViewerCustomerOrder()} className='py-0'>Dettagli</Dropdown.Item>
                                                <hr className='my-2' />
                                                <Dropdown.Item onClick={() => showModalPaymentOrder(item)} className='py-0'>Storico pagamenti</Dropdown.Item>
                                                <Dropdown.Item onClick={() => newCustomerOrderPayment(item)} className='py-0'>Registra pagamento</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <Button onClick={() => previewCustomerOrder(item)} size="sm" variant="outline-secondary" className='ms-1'><FontAwesomeIcon className='ms-1 me-1' icon='print'></FontAwesomeIcon></Button>
                                    </div>


                                    {statusModalEntityViewerCustomerOrder !== false && (
                                        <ModalEntityViewer entity={'customer_order'} item={item} status={statusModalEntityViewerCustomerOrder} closeModal={closeModalEntityViewerCustomerOrder} />
                                    )}
                                    {statusPaymentOrderModal ? (
                                        <>
                                            <Modal show={statusPaymentOrderModal} onHide={closeModalPaymentOrder} size='lg' scrollable>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Storico pagamenti</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    {dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? (
                                                        <Table className='table small'>
                                                            <thead>
                                                                <tr>
                                                                    <th>Data pagamento</th>
                                                                    <th>Importo pagato</th>
                                                                    <th>Stato</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {dataPaymentOrderModal.map((payment, i) => {
                                                                    return (
                                                                        <tr key={i}>
                                                                            <td>{moment(payment.paymentDate).format('DD/MM/YYYY')}</td>
                                                                            <td>{payment.totalPayment} €</td>
                                                                            <td>{payment.status && payment.status.value && payment.status.value === "0_PENDING" ? "In attesa" : "Generato"}</td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </Table>
                                                    ) : (
                                                        <Alert>Nessun pagamento presente.</Alert>
                                                    )}

                                                    <p className='text-end'>Totale ordine: <b>{item.totalPrice} €</b></p>
                                                    <p className='text-end'>Totale pagato: <b>{dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? dataPaymentOrderModal.reduce((acc, el) => acc + parseFloat(el.totalPayment), 0) : 0} €</b></p>
                                                    <p className='text-end'>Rimanente: <b>{dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? parseFloat(item.totalPrice - dataPaymentOrderModal.reduce((acc, el) => acc + parseFloat(el.totalPayment), 0)).toFixed(2) : parseFloat(item.totalPrice).toFixed(2)} €</b></p>
                                                </Modal.Body>
                                                <Modal.Footer>
                                                    {dataPaymentOrderModal && dataPaymentOrderModal.length > 0 ? <Button variant="outline-secondary" onClick={() => goToPreview()}>
                                                        Anteprima di stampa
                                                    </Button> : null}

                                                    <Button variant="secondary" onClick={closeModalPaymentOrder}>
                                                        Chiudi
                                                    </Button>
                                                </Modal.Footer>
                                            </Modal>
                                        </>
                                    ) : <></>}

                                </>
                            );
                        case 'gyv_supplier_order':
                            return (
                                <>
                                    <Button className='m-1' variant='outline-success' size='sm' onClick={() => openModalRows()}>Locazioni</Button>
                                    <Button className='m-1' variant='outline-secondary' size='sm' onClick={() => checkPrice()}>Confronta</Button>
                                    <Button className='m-1' variant='outline-primary' size='sm' onClick={() => openModalEntityViewerSupplierOrder()}>Dettagli</Button>
                                    <Button onClick={() => previewSupplierOrder(item)} size="sm" variant="outline-secondary" className='m-1'><FontAwesomeIcon className='ms-1 me-1' icon='print'></FontAwesomeIcon></Button>
                                    {statusModalEntityViewerSupplierOrder !== false && (
                                        <ModalEntityViewer entity={'supplier_order'} item={item} status={statusModalEntityViewerSupplierOrder} closeModal={closeModalEntityViewerSupplierOrder} />
                                    )}


                                    <Modal show={statusModalCheck} onHide={closeModalCheck}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Confronta</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Totale costo righe ordine cliente</p>
                                                    <h3>{parseFloat(totRows).toFixed(2)} €</h3>
                                                </Col>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Totale conferme d'ordine</p>
                                                    <h3>{parseFloat(totConfirm).toFixed(2)} €</h3>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col className='text-center'>
                                                    <h6>Differenza</h6>
                                                    <h2 className='text-success'>{parseFloat(totRows - totConfirm).toFixed(2)} €</h2>
                                                </Col>
                                            </Row>
                                        </Modal.Body>
                                    </Modal>



                                    <Modal show={statusModalRows} onHide={closeModalRows} size='xl'>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Locazione</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>

                                            <Row className='mb-3'>
                                                <Col>
                                                    {idArray && idArray.length > 0 ? <>
                                                        <Button variant='primary' onClick={() => openModalLocation()}>Seleziona locazione</Button>
                                                    </> : <Row>
                                                        <Col>
                                                            <h5>Seleziona una riga per procedere</h5>
                                                        </Col>
                                                    </Row>}
                                                </Col>

                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Table striped bordered>
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th>Nome</th>
                                                                <th>Descrizione</th>
                                                                <th>Quantità</th>
                                                                <th>Magazzino</th>
                                                                <th>Locazione</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {dataRows && dataRows && dataRows.rows.map((item, i) => {
                                                                return (<>
                                                                    <tr key={i}>
                                                                        <td>
                                                                            <Form.Check
                                                                                id={item.id}
                                                                                value={item.id}
                                                                                type="checkbox"
                                                                                onChange={(e) => toggleId(e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>{item.name}</td>
                                                                        <td dangerouslySetInnerHTML={{ __html: item.description }}></td>
                                                                        <td>{item.quantity}</td>
                                                                        <td>
                                                                            {item.idLocation ? item.idLocation.name : <>

                                                                            </>}
                                                                        </td>
                                                                        <td>
                                                                            {item.idLocation ? item.idLocation.idWarehouse.name : <>

                                                                            </>}
                                                                        </td>
                                                                    </tr>
                                                                </>)
                                                            })}

                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </Modal.Body>
                                    </Modal>



                                    <ModalListPicker entity={'location'} closeModal={closeModalLocation} modalStatus={statusModalLocation} selectRow={selectRow} />
                                </>
                            );
                        case 'invoice':
                            return (
                                <>
                                    <Button size="sm" onClick={() => downloadXml()}>Download XML</Button>
                                    <Button size="sm" className='ms-1' variant='outline-secondary' onClick={() => generateXml(item)}>Rigenera XML</Button>
                                    {/* <Button size="sm" className='ms-1' variant='outline-secondary' onClick={() => printInvoice(item)}>Stampa fattura</Button> */}
                                </>
                            );
                        case 'customer_order_payment':
                            return (
                                <>
                                    <Button size="sm" variant='outline-primary' onClick={() => openModal()}>Genera XML</Button>
                                    {item.status && item.status.value !== "10_PAID" ? <>
                                        <Button size="sm" className='mx-1' variant='outline-success' onClick={() => paidInvoice()}>Pagata</Button>
                                    </> : null}



                                    <Modal show={showModal} onHide={closeModal} size='lg'>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Progressivo</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                        <Form.Label>Inserisci progressivo</Form.Label>
                                                        <Form.Control type="number" onChange={(e) => setProgressivo(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                        <Form.Label>Inserisci aliquota</Form.Label>
                                                        <Form.Control type="number" onChange={(e) => setAliquota(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                        <Form.Label>Inserisci causale</Form.Label>
                                                        <Form.Control type="text" onChange={(e) => setCausale(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label className='mb-2'>Inserisci descrizione</label>
                                                    <Editor
                                                        apiKey={settings.tinyKey}
                                                        onEditorChange={(value) => setDescrizione(value)}
                                                        init={{
                                                            height: 500,
                                                            menubar: true,
                                                            plugins: [
                                                                'lists', 'link', 'image', 'preview',
                                                                'visualblocks', 'code', 'fullscreen',
                                                                'media', 'table', 'advlist', 'code', 'wordcount'
                                                            ],
                                                            toolbar: 'undo redo | formatselect | ' +
                                                                'bold italic backcolor | alignleft aligncenter ' +
                                                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                                                'removeformat | fullscreen',
                                                            content_style: 'body { font-family:Helvetica,Arial,sans-serif;font-size:14px; }'
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={closeModal}>
                                                Indietro
                                            </Button>
                                            <Button variant="primary" onClick={() => generateXMLV2()}>
                                                Genera
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </>
                            );
                        default:
                            return (
                                <></>
                            );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};